import { Close, SaveAlt } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { connect } from 'react-redux'
import { NivosCommentSection } from 'components/index'
import NivosRTE from 'components/nivos-rte'
import image1 from 'images/demo3.png'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as NivosPostOperations,
  operations as nivosPostOperations
} from 'states/dux/nivos-post/operations'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import NivosPost from 'types/nivos-post'
import {
  post as apiPost,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    nivosPost: NivosPostOperations
  }
}

interface OwnProps {
  post: NivosPost | undefined
  setPost: (_: NivosPost | undefined) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const PostModalViewFC: React.FC<any> = (props: AppProps) => {
  const { post, setPost, operations } = props
  const isMobileView = useMediaQuery('(max-width:600px)')

  const addComment = (comment: string): void => {
    if (post !== undefined) {
      void apiPost(`/post/${post.id}/add_comment/`, { comment }).then(data => {
        operations.nivosPost.update(objectifyDateStringFields(data))
      })
    }
  }

  return (
    <Modal open={post !== undefined} onClose={() => setPost(undefined)}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        height={1}
      >
        {post !== undefined && (
          <Paper
            variant={'elevation'}
            sx={{
              width: isMobileView ? '95vw' : 800,
              minHeight: '50vh',
              maxHeight: isMobileView ? '100vh' : '90vh',
              overflow: 'auto',
              padding: 2,
              borderRadius: '6px'
            }}
            elevation={8}
          >
            <Box
              display={'flex'}
              justifyContent={'flex-start'}
              alignItems={'center'}
              padding={2}
            >
              <Avatar
                src={post?.createdBy.image?.url}
                sx={{ height: 70, width: 70, marginRight: 1 }}
              />
              <Box padding={1} flexGrow={1}>
                <Typography variant={'h4'}>
                  {`${post.createdBy.firstName} ${post.createdBy.lastName}`}
                </Typography>
                <Typography>{new Date().toLocaleString()}</Typography>
              </Box>
              <Box>
                <Tooltip placement={'top'} title={'Save post'}>
                  <IconButton>
                    <SaveAlt />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box display={'flex'} alignItems={'center'}>
                <IconButton onClick={() => setPost(undefined)}>
                  <Close color={'primary'} />
                </IconButton>
              </Box>
            </Box>
            <Divider />
            <Box paddingY={4}>
              <Typography align={'center'} variant={'h3'}>
                {post.title}
              </Typography>
            </Box>
            {post.images !== undefined && post.images.length > 0 && (
              <img
                src={post.images[0].url}
                width={'100%'}
                height={200}
                alt={'selected-nivos-post-cover-image'}
                style={{
                  objectFit: 'cover',
                  borderRadius: 8,
                  cursor: 'pointer'
                }}
              />
            )}
            {post.images === undefined && (
              <img
                src={image1}
                width={'100%'}
                height={200}
                alt={'post-cover'}
                style={{ objectFit: 'cover', borderRadius: 8 }}
              />
            )}
            <Box padding={2} paddingY={3}>
              {post.contentRte.trim() === '' && (
                <Typography>{post.content}</Typography>
              )}
              {post.contentRte.trim() !== '' && (
                <NivosRTE
                  rteState={post.contentRte}
                  setRteState={() => null}
                  readOnly={true}
                />
              )}
            </Box>
            <Divider />
            <Box padding={2}>
              <NivosCommentSection
                comments={post.comments}
                submitFnCallback={comment => addComment(comment)}
              />
            </Box>
          </Paper>
        )}
      </Box>
    </Modal>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  nivosPost: nivosPostOperations
})

const PostModalView = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostModalViewFC) as React.FC<OwnProps>

export default PostModalView
